import axios from "axios";
import config from "../config/index";
import authService from "../services/AuthService";
import { USER_TYPE_HEADER } from "../auth/userTypeUtils";

const PUBLIC_PATH_SUFFIXES = [
  "/login",
  "/users/mail/password-reset",
  "/users/mail/passwordUpdate",
];

function isPublicRequest(url = "") {
  return PUBLIC_PATH_SUFFIXES.some((suffix) => url.includes(suffix));
}

const instance = axios.create({
  baseURL: config.baseUrl,
});

instance.interceptors.request.use(
  async (config) => {
    const token = await authService.getToken();
    if (token) {
      config.headers["authorization"] = `Bearer ${token}`;
    }

    const url = String(config.url || "");
    const match = url.match(/[?&]usertype=([^&]+)/i);
    if (match) {
      config.headers[USER_TYPE_HEADER] = decodeURIComponent(match[1]);
    } else if (!isPublicRequest(config.url)) {
      const userType = await authService.getUserType();
      if (userType) {
        config.headers[USER_TYPE_HEADER] = userType;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const originalConfig = error.config;

    const isNetworkError =
      error.code === "ERR_NETWORK" || error.message === "Network Error";
    const isGet = (originalConfig?.method || "get").toLowerCase() === "get";
    const retryCount = originalConfig?.__networkRetryCount || 0;

    if (originalConfig && isNetworkError && isGet && retryCount < 2) {
      originalConfig.__networkRetryCount = retryCount + 1;
      return instance.request(originalConfig);
    }

    const message = error.response?.data?.message;
    const requestUrl = error.config?.url ?? "";
    const isLoginRequest = requestUrl.includes("/login");
    const isPasswordMismatch = message === "Password not matched";

    if (status === 401 && !isLoginRequest && !isPasswordMismatch) {
      const token = await authService.getToken();
      if (token) {
        await authService.logout();
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
